import React, { FC, useCallback, useState } from 'react';
import styles from './index.module.scss';
import { Button } from 'src/common';
import { useTranslation } from 'react-i18next';
import { MatchingProfileCreate } from 'src/shared';
import LearnMoreLink from 'src/shared/LearnMoreLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-light-svg-icons';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';

export const EmptyMatchingProfilesList: FC = () => {
  const { t, i18n } = useTranslation();
  const isKnowledgeBankFeature = useFeatureFlag(FeatureFlag.KnowledgeBank);

  const [modalVisible, setModalVisible] = useState(false);
  const hideModal = useCallback(() => {
    setModalVisible(false);
  }, []);
  const showModal = useCallback(() => {
    setModalVisible(true);
  }, []);

  return (
    <div className={styles.emptyMessage}>
      <div className={styles.content}>
        <FontAwesomeIcon icon={faSparkles} className={styles.icon} />
        <div className={styles.title}>{t('Tenders.mpListIsEmptyMessageTitle')}</div>
        <p className={styles.text}>{t('Tenders.mpListIsEmptyMessage')}</p>

        {isKnowledgeBankFeature && (
          <div className={styles.container}>
            <LearnMoreLink
              title={t('Tenders.learnMoreAboutMP')}
              href={`${import.meta.env.VITE_HELPDOCS_DOMAIN}${
                i18n.language
              }/article/tfb28vq044-configure-your-tender-monitoring-profile`}
            />

            <Button onClick={showModal} type="primary" className={styles.button}>
              {t('Tenders.createMP')}
            </Button>
          </div>
        )}
      </div>
      {modalVisible && <MatchingProfileCreate onHide={hideModal} />}
    </div>
  );
};

export default EmptyMatchingProfilesList;
